import { supabase } from "@/integrations/supabase/client";

export interface SetEmailPasswordRequest {
  email: string;
  password: string;
}

export interface SetEmailPasswordResponse {
  status: string;
  message: string;
}

export const authService = {
  async setEmailPassword(
    email: string,
    password: string
  ): Promise<SetEmailPasswordResponse> {
    // Получаем текущую сессию пользователя
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session) {
      throw new Error("errors.unauthorized");
    }

    const setEmailPasswordUrl = import.meta.env.VITE_EMAIL_PASSWORD_URL;
    if (!setEmailPasswordUrl) {
      throw new Error("errors.auth.config_missing");
    }

    const response = await fetch(setEmailPasswordUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));

      // Обработка специфических ошибок из API документации
      if (response.status === 400) {
        throw new Error(errorData.detail || "errors.auth.invalid_data");
      }
      if (response.status === 401) {
        throw new Error("errors.auth.unauthorized");
      }
      if (response.status === 403) {
        throw new Error("errors.auth.telegram_only");
      }
      if (response.status === 500) {
        throw new Error("errors.auth.failed_create");
      }

      throw new Error(
        errorData.detail || `Ошибка ${response.status}: ${response.statusText}`
      );
    }

    return await response.json();
  },
};
